import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import ServiceForm from "./ServiceForm";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";
import ServiceRedirect from "./ServiceRedirect";


function Services(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   

        fak_kontrahenci_id:  defId,  

        nazwa:  props.mainView.readFilter('serv_nazwa',''),   
        nip:  props.mainView.readFilter('serv_nip',''),    
        accuntcode:  props.mainView.readFilter('serv_accuntcode',''),   
        numer_info:  props.mainView.readFilter('serv_numer_info',''),   
        numer_pstn:  props.mainView.readFilter('serv_numer_pstn',''),   

        stan_umowy:  props.mainView.readFilter('serv_stan_umowy','_x_'),   
        fakturowac:  props.mainView.readFilter('serv_fakturowac','_x_'),   

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    
    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'umowa nieaktywna',
            filter: {  filed: "stan_umowy", set: "2", typ: "combo"  },
        },
    ]);



    
        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 5000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('serv_nazwa', '');
            props.mainView.writeFilter('serv_nip', ''); 
            props.mainView.writeFilter('serv_accuntcode', '');
            props.mainView.writeFilter('serv_numer_info', '');
            props.mainView.writeFilter('serv_numer_pstn', '');
            props.mainView.writeFilter('serv_stan_umowy', '_x_');
            props.mainView.writeFilter('serv_fakturowac', '_x_');
           

            var defId = -1;
            if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

            setFilterParam({
                
                fak_kontrahenci_id:  defId, 

                nazwa: '',                 
                nip: '',                 
                sl_typ_uslugi_id: '_x_',                 
                stan_umowy: '_x_',                 
                fakturowac: '_x_',                 
                accuntcode: '',                 
                numer_info: '',                 
                numer_pstn: '',                 
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }



          const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
            }


            const onBack = ( ) => {                
                    setView({...view, ["v"]:"list", ["id"]:-1 });               
                }

            
            const onSuccess = ( ) => {                
                    setView({...view, ["v"]:"list", ["id"]:-1 });       
                    getTab();
                }

                

    const getTab = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_home,services', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }



        const deleteRecord = (e) => {
                
                var id = e.target.getAttribute('atr-id');
                var title = e.target.getAttribute('atr-title');

                props.mainView.showDialog("Pytanie" , "Czy na pewno chcesz usunąć: " + title  ,  "yesno"  , ( resp) => {
                              
                                if(resp == "yes")
                                {
                                    //-----------------
                                
                                        props.mainView.showProgress();        

                                                fetch( Config.url + '/rest_v1_home,service_remove', {
                                                    method: 'POST', 
                                                    body: JSON.stringify({id: id}), 
                                                    headers: {
                                                        'Content-Type': 'application/json',                    
                                                        'X-Api-Key': props.userData.apiKey,
                                                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                        '_sec_key_': Config.genXKey() ,
                                                    }
                                                })
                                                .then(res => res.json() )
                                                .then(res => { 

                                                            props.mainView.hideProgress();

                                                            if(res._sys_ == undefined)
                                                            {
                                                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                            }else
                                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                            {
                                                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                            }else    
                                                            {
                                                                      getTab();
                                                                      props.mainView.showDialog( "Sukces", "Usługa została usunięta z umowy", "ok" , null);                                        
                                                            }
                                                } )
                                                .catch(err => {          
                                                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                            props.mainView.hideProgress();
                                                });

                                    //-----------------
                                }
                })

            }



       const keyListener = (e)     => {

                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                                filterClear();
                        }else                            
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                                filterClear();
                        }else                                                                     
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                                setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        }else                                              
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                            props.keyListener(e);
                        }

       }


       useEffect( ()=>{

            if(Config.env == "dev") console.log("Services.js, listener on");
            window.onkeydown = keyListener;                       
            
            return () => {   
                 if(Config.env == "dev") console.log("Services.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );








    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        setTab(null);
    }



    if(tab == null)
    {
        setTab([]);
        getTab();    
        return <div>
            ...
        </div>
    }


    if(view.v == "edit")
    {
        var findRow = {};

        for(var k=0; k < tab.length; k++)
        {
            if(tab[k].id == view.id)
            {
                findRow =  tab[k];
            }
        }


        return <ServiceForm userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id} umowa={findRow.umowa} fak_kontrahenci_id={-1} />
    }


     if(view.v == "redirect")
    {
        var findRow = {};

        for(var k=0; k < tab.length; k++)
        {
            if(tab[k].id == view.id)
            {
                findRow =  tab[k];
            }
        }

        return <ServiceRedirect userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={findRow.pg6_uslugi_id} umowa={findRow.umowa} usluga={findRow} fak_kontrahenci_id={-1} />
    }

    
    document.title = "Lista usług";


            var sortList = [                
            {column: "created_at", name: "Data utworzenia"  },         
            {column: "firma_nazwa", name: "Nazwa firmy"  },
            {column: "id", name: "Id"  },
            {column: "id_asterisk", name: "Id Asterisk"  },
            ]

   var titleRaport = "Lista usług";
    

    return  <div className="view_content">

            

                <h3 className="dash_header">Lista usług</h3>

    
               
                            <div className="table_filter">

                                    {
                                        filterParam.fak_kontrahenci_id <= 0 &&
                                        <Fragment>

                                                <div className="filter_controll">   
                                                        <label>Nazwa: </label>                             
                                                        <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                                                </div> 
                                                
                                                <div className="filter_controll">   
                                                        <label>NIP: </label>                             
                                                        <InputText   userData={props.userData} value={filterParam.nip}   valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"NIP: "}   />
                                                </div> 
                                            
                                        </Fragment>
                                    }
                                    


                                    <div className="filter_controll">   
                                        <label>Status umowy: </label>                             
                                        <InputCombo items={ [{v:"_x_",title:'- - - '},{v:"1",title:'Aktywna'}, {v:"2",title:'Nieaktywna'}] }   userData={props.userData} value={filterParam.stan_umowy}   valChange={valChangeListener} goNext={goNextNew} name="stan_umowy" placeholder={": "}   />
                                    </div> 

                                    <div className="filter_controll">   
                                        <label>Fakturowanie: </label>                             
                                        <InputCombo items={ [{v:"_x_",title:'- - - '},{v:"1",title:'Tak'}, {v:"0",title:'Nie'}] }   userData={props.userData} value={filterParam.fakturowac}   valChange={valChangeListener} goNext={goNextNew} name="fakturowac" placeholder={": "}   />
                                    </div> 
                                 
                                 

                                   <div className="filter_controll">   
                                            <label>AccountCode: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.accuntcode}   valChange={valChangeListener} goNext={goNextNew} name="accuntcode" placeholder={"AccountCode: "}   />
                                    </div> 

                                      <div className="filter_controll">   
                                            <label>Nr info: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.numer_info}   valChange={valChangeListener} goNext={goNextNew} name="numer_info" placeholder={"Numer info: "}   />
                                    </div> 


                                     <div className="filter_controll">   
                                            <label>Nr pstn: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.numer_pstn}   valChange={valChangeListener} goNext={goNextNew} name="numer_pstn" placeholder={"Numer pstn: "}   />
                                    </div> 


                                    <div className="filter_btn">                       
                                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                                    </div> 
                        </div>


                        <div className="table_widget">                             

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />


                              &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                        </div>


                        <div className="bg_center">


                               <div ref={tabRef} className="gohide">
                                     <h3>{titleRaport}</h3> 
                                     <table className="table" ref={tab2Ref} >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                           
                                                <td>Nazwa</td>                                                                                                                                    
                                                <td>Umowa</td>                                                                                                                                    
                                                <td>Nazwa usługi</td>                                                                                      
                                                <td>Aktywacja</td>                                                                                      
                                                <td>Abonament</td>                                                                                      
                                                <td>Fakturowanie</td>                                                                                                                                                                                                                          
                                                <td>Nr PSTN</td>                                                                                      
                                                <td className="td_right">Nr INFO</td>                                                                                                                                                                                                                       
                                                                                                                    
                                            </tr>
                                        </thead>

                                        <tbody>

                                           
                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(row.umowa.stan_umowy == '2') rowStyle = rowStyle + " color_deleted ";

                                                            var nazwa = row.umowa.klient.nazwa;
                                                            if(nazwa.length > 10) nazwa = nazwa.substring(0,10)+"...";

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>
                                                                <td v="edit" id={row.id} onClick={changeView} >{nazwa}</td>
                                                                <td className="gocenter" v="edit" id={row.id} onClick={changeView} >{row.umowa.numer_umowy}</td>
                                                                <td  v="edit" id={row.id} onClick={changeView} >{row.nazwa_uslugi}</td>                                                         
                                                                <td className="goright"><FormatDecimal value={row.aktywacja} /></td>
                                                                <td className="goright"><FormatDecimal value={row.abonament} /></td>
                                                                <td className="gocenter">

                                                                    {
                                                                        row.fakturowac == 1 && 
                                                                        <Fragment>Tak</Fragment>
                                                                    }

                                                                    {
                                                                        row.fakturowac == 0 && 
                                                                        <Fragment>Nie</Fragment>
                                                                    }

                                                                </td>
                                                                <td className="gocenter">{row.numer_pstn}</td>
                                                                <td className="gocenter goright">{row.numer_info}</td>                                                       
                                                             
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>
                                </div>

                                <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                           
                                                {
                                                   props.fak_kontrahenci_id == undefined && 
                                                   <td>Nazwa</td>
                                                }                                                                                                                                                                                    
                                                <td>Umowa</td>                                                                                                                                    
                                                <td>Nazwa usługi</td>                                                                                      
                                                <td>ID</td>                                                                                      
                                                <td>ID_Asterisk</td>                                                                                      
                                                <td>AccountCode</td>                                                                                      
                                                <td>Aktywacja</td>                                                                                      
                                                <td>Abonament</td>                                                                                      
                                                <td>Fakturowanie</td>                                                                                                                                                                                                                          
                                                <td>Nr PSTN</td>                                                                                      
                                                <td className="td_right">Nr INFO</td>                                                                                                                                                                                                                       
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                           
                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(row.umowa.stan_umowy == '2') rowStyle = rowStyle + " color_deleted ";

                                                            var nazwa = row.umowa.klient.nazwa;
                                                            if(nazwa.length > 10) nazwa = nazwa.substring(0,10)+"...";

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>
                                                                {
                                                                  props.fak_kontrahenci_id == undefined && 
                                                                  <td v="edit" id={row.id} onClick={changeView} >{nazwa}</td>
                                                                } 
                                                                
                                                                <td className="gocenter" v="edit" id={row.id} onClick={changeView} >{row.umowa.numer_umowy}</td>
                                                                <td  v="edit" id={row.id} onClick={changeView} >{row.nazwa_uslugi}</td>                                                         
                                                                <td  v="edit" id={row.id} onClick={changeView} className="gocenter" >{row.id}</td>                                                         
                                                                <td  v="edit" id={row.id} onClick={changeView} className="gocenter" >{row.pg6_uslugi_id}</td>                                                         
                                                                <td  v="edit" id={row.id} onClick={changeView} className="gocenter" >{row.accountcode}</td>                                                         
                                                                <td className="goright"><FormatDecimal value={row.aktywacja} /></td>
                                                                <td className="goright"><FormatDecimal value={row.abonament} /></td>
                                                                <td className="gocenter">

                                                                    {
                                                                        row.fakturowac == 1 && 
                                                                        <Fragment>Tak</Fragment>
                                                                    }

                                                                    {
                                                                        row.fakturowac == 0 && 
                                                                        <Fragment>Nie</Fragment>
                                                                    }

                                                                </td>
                                                                <td className="gocenter">{row.numer_pstn}</td>
                                                                <td className="gocenter goright">{row.numer_info}</td>                                                       
                                                                <MenuTable>
                                                                    <ul>                                                                     
                                                                        <li v="edit" id={row.id} onClick={changeView}>Zmień dane</li>
                                                                        <li v="redirect" id={row.id} onClick={changeView}>Przekierowania</li>
                                                                        <li v="delete" atr-id={row.id} atr-title={row.nazwa_uslugi} onClick={deleteRecord}>Usuń</li>
                                                                    </ul>
                                                                </MenuTable>
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>


                        </div>
           
        </div>


}


export default Services;